import { ApiResponse, getData, postData } from './Apis';

export type PrivacyPolicyData = {
    PolicyUpdatedDate: Date,
}

export async function API_GetPrivacyPolicyData() : Promise<ApiResponse<PrivacyPolicyData>> {
    return await getData<ApiResponse<PrivacyPolicyData>>("webapi/candidate/user/GetPrivacyPolicyData"); 
}

export async function API_ConfrimPrivacyPolicy(): Promise<ApiResponse<boolean>>{
    return await postData("webapi/candidate/user/ConfirmPrivacyPolicy"); 
}